// extracted by mini-css-extract-plugin
module.exports = {"boxActions":"style_boxActions__HhzY1","buttonWrapper":"style_buttonWrapper__arsug"};